/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Navtitles_Dashboard1Inputs */

const en_navtitles_dashboard1 = /** @type {(inputs: Navtitles_Dashboard1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DASHBOARD`)
};

/**
* | output |
* | --- |
* | "DASHBOARD" |
*
* @param {Navtitles_Dashboard1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const navtitles_dashboard1 = /** @type {((inputs?: Navtitles_Dashboard1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Navtitles_Dashboard1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_navtitles_dashboard1(inputs)
});
export { navtitles_dashboard1 as "navTitles_dashboard" }